import {Logo} from "./Logo";
import React from "react";
import './Logo.scss';

export const LogoContainer = (props: { extraMarginTop?: boolean }) => {
    return <div className={`logoContainer ${props.extraMarginTop ? 'logoContainer__extraMarginTop' : ''} `}>
        <Logo/>
    </div>
}